import React from 'react'
import { BenefitsList, BenefitItem } from './LoyaltySignInModal.css'

const CheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0, paddingTop: '3px' }}>
    <circle cx="10" cy="10" r="10" fill="#34A853" />
    <path d="M5.5 10.5L8.5 13.5L14.5 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const ALL_BENEFITS = [
  <>Join CarParts+ free and <b>earn 25 points instantly</b>.</>,
  <>Earn points on every order, <b>500 points = $10 reward</b>.</>,
  <>Save vehicles, addresses, and payments for <b>faster checkout</b>.</>,
]

const SIGNIN_BENEFITS = ALL_BENEFITS.slice(1)

type BenefitsBlockProps = {
  variant?: 'signin' | 'createaccount'
}

const BenefitsBlock: React.FC<BenefitsBlockProps> = ({ variant = 'createaccount' }) => {
  const benefits = variant === 'signin' ? SIGNIN_BENEFITS : ALL_BENEFITS
  return (
    <BenefitsList>
      {benefits.map((text, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <BenefitItem key={i}>
          <CheckIcon />
          <span>{text}</span>
        </BenefitItem>
      ))}
    </BenefitsList>
  )
}

export default BenefitsBlock
